import React from 'react'
import { useSelector } from 'react-redux'
import CardDiagnosisProcedure from '../../../../../components/common/CardDiagnosisProcedure/CardDiagnosisProcedure'

import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd'
import { isAICPT } from '../sharedPanelComponents/sharedAIfunctions'

export default function PanelSelectedChargesDisplay({ selectedCPT, setSelectedCPT }) {
  const features = useSelector((state) => state.user?.features) || []
  const coding_ai = useSelector((state) => state.sidePanel.panelEncounter?.coding_ai)
  const aiCptCodeCheck = useSelector((state) => state.sidePanel.panelEncounter?.aiCptCodeCheck)
  const service_date_from = useSelector(
    (state) => state.sidePanel.panelEncounter?.service_date_from,
  )
  const isReadOnly = useSelector((state) => state.sidePanel.isReadOnly)

  const onDragEnd = (result) => {
    if (!result.destination) {
      return
    }

    const reorderedArr = Array.from(selectedCPT)
    const [removed] = reorderedArr.splice(result.source.index, 1)
    reorderedArr.splice(result.destination.index, 0, removed)
    setSelectedCPT(reorderedArr)
  }

  const onModifierAdd = (item) => {
    if (item) {
      const selectedListWithMod = [...selectedCPT]
      let index = selectedCPT.findIndex((code) => code.code === item.code)

      if (index > -1) {
        selectedListWithMod[index] = item
      }

      setSelectedCPT(selectedListWithMod)
    }
  }

  return (
    <div
      className={`PanelSelectedChargesDisplay ${selectedCPT?.length > 0 ? '' : 'empty'}`}
      style={{ pointerEvents: isReadOnly ? 'none' : '' }}
    >
      {selectedCPT?.length > 0 ? (
        <DragDropContext onDragEnd={onDragEnd}>
          <Droppable droppableId="droppable">
            {(provided) => {
              return (
                <div ref={provided.innerRef} {...provided.droppableProps}>
                  {selectedCPT?.map((item, index) => {
                    const key = item?.code
                    return (
                      <Draggable key={key} draggableId={key} index={index}>
                        {(provided) => (
                          <CardDiagnosisProcedure
                            item={item}
                            icon={'minus'}
                            index={index}
                            onModifierAdd={onModifierAdd}
                            handleAddRemove={() =>
                              setSelectedCPT(
                                selectedCPT.filter((_, cptIndex) => cptIndex !== index),
                              )
                            }
                            serviceDate={service_date_from}
                            selectedList={selectedCPT}
                            type={'PROCEDURE'}
                            panelSelected={true}
                            innerRef={provided.innerRef}
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                            isAI={
                              isAICPT(coding_ai, features, item?.code) ||
                              item?.code === aiCptCodeCheck?.code
                            }
                          />
                        )}
                      </Draggable>
                    )
                  })}
                  {provided.placeholder}
                </div>
              )
            }}
          </Droppable>
        </DragDropContext>
      ) : (
        <div id="no-results">No CPTs Selected</div>
      )}
    </div>
  )
}
